import { render, staticRenderFns } from "./proposte.vue?vue&type=template&id=cf8e0db4&"
import script from "./proposte.vue?vue&type=script&lang=js&"
export * from "./proposte.vue?vue&type=script&lang=js&"
import style0 from "./proposte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports